import { Link } from "react-router-dom";
import Reveal from "./Reveal";
import ZaidPhoto from "../assests/Zaid_photo.webp";
import VikasPhoto from "../assests/Vikas_photo.webp";

const ARTISTS = [
  {
    name: "Mohammed Zaid",
    role: "Co-founder · Lead Muralist",
    bio: "MFA in painting. Zaid's hand draws the gesture, the figure, the loud colour. He leads the studio's on-site practice.",
    img: ZaidPhoto,
    link: "/about#mohammadzaid",
  },
  {
    name: "Vikas Mandal",
    role: "Co-founder · Studio Director",
    bio: "BA, MA (open). Vikas shapes the studio's visual language — composition, palette, and the quiet decisions behind every wall.",
    img: VikasPhoto,
    link: "/about#vikasmandal",
  },
  {
    name: "Abdul Quadir",
    role: "Creative Director",
    bio: "BFA, MFA (Jamia Millia Islamia). Abdul brings academic rigor and contemporary vision to the studio, translating complex narratives into striking visual layouts.",
    img: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/team%2F4.webp?alt=media&token=e4c84e5a-2629-43de-98cf-6dc48c0e38a2",
    link: "/about#abdulqadir",
  },
];

export default function Artists() {
  return (
    <section className="relative py-24 md:py-40 px-5 md:px-10 bg-[var(--bg)] overflow-hidden">
      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-3">
            <Reveal>
              <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay)]">
                — The Hands
              </div>
              <div className="mt-3 font-display text-5xl md:text-7xl text-[var(--bone)]">
                03
              </div>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-9">
            <Reveal delay={120}>
              <h2 className="font-display font-light text-[clamp(2.5rem,5.5vw,5rem)] leading-[1.05] tracking-tight text-[var(--bone)]">
                Two artists. <span className="italic font-extralight">One</span> studio. A wall waiting for its story.
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-10">
          {ARTISTS.map((a, i) => (
            <Reveal key={a.name} delay={i * 120}>
              <Link
                to={a.link}
                className="group block relative overflow-hidden bg-[var(--bg-elevated)]"
              >
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={a.img}
                    alt={a.name}
                    loading="lazy"
                    className="w-full h-full object-cover  transition-all duration-1000 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)] via-transparent to-transparent" />

                {/* Top corner index */}
                <div className="absolute top-5 left-5 text-[10px] uppercase tracking-[0.32em] text-[var(--bone)]/80 flex items-center gap-2">
                  <span className="font-display text-2xl text-[var(--clay)] leading-none tabular-nums">
                    0{i + 1}
                  </span>
                  <span className="block w-6 h-px bg-[var(--bone)]/60" />
                  Co-founder
                </div>

                <div className="absolute left-0 right-0 bottom-0 p-6 md:p-10">
                  <h3 className="font-display text-3xl md:text-5xl text-[var(--bone)] leading-none">
                    {a.name}
                  </h3>
                  <div className="mt-2 text-[10px] uppercase tracking-[0.32em] text-[var(--clay-light)]">
                    {a.role}
                  </div>
                  <p className="mt-4 text-[var(--bone)]/80 max-w-md text-[15px] leading-relaxed">
                    {a.bio}
                  </p>
                  <div className="mt-6 inline-flex items-center gap-2 text-sm text-[var(--bone)] link-underline">
                    Read full story
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M5 12h14M13 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal delay={300}>
          <div className="mt-16 text-center">
            <Link
              to="/team"
              className="inline-flex items-center gap-3 px-6 py-3 border border-[var(--line-strong)] text-[var(--bone)] rounded-full text-sm tracking-wide hover:border-[var(--clay)] hover:text-[var(--clay)] transition-colors"
            >
              Meet the full team
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}